import GridController from 'react-mui-lib/grid/controller';

export default new GridController({
    entity_name: 'region',
    state_prefix: 'region_grid',
    default_order_col: 'name',
    default_order_dir: 'asc'
});
